// extracted by mini-css-extract-plugin
export default {"notFoundPage":"maintain_notFoundPage__13Kov","IconNotFound":"maintain_IconNotFound__fDcHM","bigText":"maintain_bigText__l5Eeo","smallText":"maintain_smallText__jBJ0e"};